<template>
  <petition-lockable-field-layout :field-name="fieldName" :label="label" :show-lock="showLock"
                                  :can-change-lock="fieldCanBeLocked" :initial-locked="initialLocked"
                                  :input-id="inputId" :required="required"
                                  :lock-update-path="lockUpdatePath">
    <template #readonly-field>
      <input :id="inputId" type="hidden" :name="inputName" :value="value">
      <span :class="['form-control', 'readonly-rich-text', `readonly-${fieldName}`]" v-html="value" />
    </template>
    <template #editable-field>
      <trix-text-input ref="trixInput" :input-name="inputName" :value="value" :validation-errors="validationErrors"
                       :show-html-mode="false" :show-attach-files="false" :show-code-button="false"
                       :show-heading-button="false" @input="updateFieldValue" />
    </template>
  </petition-lockable-field-layout>
</template>

<script>
import FieldWithLock from '@/mixins/field-with-lock'
import PetitionLockableFieldLayout from '@/components/petition-lockable-field-layout'
import { Popover } from 'bootstrap'
import kebabCase from 'lodash/kebabCase'
import TrixTextInput from '@/components/inputs/trix-text-input'

export default {
  components: { PetitionLockableFieldLayout, TrixTextInput },

  mixins: [ FieldWithLock ],

  props: {
    fieldName: {
      type: String,
      required: true
    },
    helpPopoverContent: {
      type: String,
      required: false
    },
    hideHelpPopover: {
      type: Boolean,
      required: true
    },
    initialValue: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    validationErrors: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      value: this.initialValue
    }
  },

  computed: {
    fieldCanBeLocked() {
      return this.canChangeLock && this.value?.length > 0
    },
    inputName() {
      return `petition[${this.fieldName}]`
    },
    inputId() {
      return kebabCase(this.inputName)
    },

    trixEditorId() {
      if (!this.$refs.trixInput) {
        return null
      }

      return this.$refs.trixInput.editorId
    }
  },

  watch: {
    locked(newLockValue) {
      // If the field was unlocked, initialize the popover so it's displayed when the rich text area gets focus
      if (!newLockValue) {
        this.$nextTick(() => {
          this.initializePopover()
        })
      }
    }
  },

  mounted() {
    this.initializePopover()
  },

  methods: {
    initializePopover() {
      if (this.hideHelpPopover || !this.trixEditorId) {
        return
      }

      // TODO: DRY with app/javascript/popovers.js (?)
      const popoverTemplate = '<div class="popover" role="tooltip"><div class="popover-arrow"></div><div class="popover-inner"><div class="popover-body"><p></p></div></div></div>'
      const trixEditorEl = document.getElementById(this.trixEditorId)

      new Popover(trixEditorEl, {
        content: this.helpPopoverContent,
        placement: 'right',
        html: true,
        template: popoverTemplate,
        trigger: 'focus'
      })
    },

    updateFieldValue(newValue) {
      this.value = newValue
    }
  }
}
</script>

<style lang="scss" scoped>
@use "~friendship_styles/colors" as colors;

.readonly-rich-text {
  // Give it the same height as the trix editor and its toolbar to minimize the flickering when locking / unlocking the field
  height: 440px;
  overflow: scroll;
  background-color: colors.$widget-background-dark-gray;
}
</style>
